import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { Button, ButtonTheme } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLessThan } from '@fortawesome/free-solid-svg-icons';
import '../../scss/_applicationEntryNavigationButtons.scss';

type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryNavigationButtonsProps {
    printMode?: boolean;
    nextStepButtonProps: ButtonProps;
    previousStepButtonVisible?: boolean;
}

export const ApplicationEntryNavigationButtons: React.FC<ApplicationEntryNavigationButtonsProps> = ({
    printMode,
    nextStepButtonProps,
    previousStepButtonVisible,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry-navigationButtons'>
                {previousStepButtonVisible && (
                    <Button
                        id='applicationEntry-backButton'
                        dataTestid='applicationEntryBackButton'
                        theme={ButtonTheme.LinkBlue}
                        // handleClick={b.handleClick}
                    >
                        <span style={{ paddingRight: '5px' }}>
                            <FontAwesomeIcon icon={faLessThan} />
                        </span>
                        Back
                    </Button>
                )}
                <Button
                    id={nextStepButtonProps.id}
                    dataTestid={nextStepButtonProps.dataTestid}
                    theme={ButtonTheme.Primary}
                    width='50%'
                    maxWidth='346px'
                    handleClick={nextStepButtonProps.handleClick}
                    disabled={nextStepButtonProps.disabled}
                >
                    {nextStepButtonProps.children}
                </Button>
            </div>
        </>
    );
};
